import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';
import { navigationCompetitionIdAtom } from '@/atoms/navigation';
import { LEAGUE_BASE_ROUTE, useLeagueNavigationItems } from './subNavigation/useLeagueNavigationItems';

export const useLeagueNavigationItem = () => {
  const { t } = useTranslation('navigation');
  const iqLeagueId = useAtomValue(navigationCompetitionIdAtom);
  const leagueRoute = `${LEAGUE_BASE_ROUTE}${iqLeagueId}/league-table`;

  return {
    id: 'leagues',
    icon: 'League' as const,
    path: leagueRoute,
    label: t('crossPlatform.primary.leagues'),
    subNav: useLeagueNavigationItems(),
  };
};
